
import { Component, Prop, Vue } from "vue-property-decorator";
import { Mutation } from "vuex-class";

@Component
export default class BackButton extends Vue {
  @Prop() private path!: string;
}

